// One remark an auditor wrote beside a question while doing the work
export class InternalAuditCommentDTO {
  taskId!: number;

  taskName?: string;

  procedureTaskId?: number;

  procedureName?: string;

  coveredItemNames?: string[];

  kpiId!: number;

  question?: string;

  comment?: string;

  commentHtml?: string;

  // the audit criterion behind the question, when it was generated from one
  entityType?: number;

  entityId?: number;

  criterionKey?: string;

  entityName?: string;
}

// Execution work that was done without a library procedure and carries enough of its own content to
// become one. The existing* fields say the name it would be given is already taken, so applying it
// improves that procedure instead of adding a second one under the same name.
export class InternalAuditUnmatchedTaskDTO {
  taskId!: number;

  taskName?: string;

  description?: string;

  coveredItemNames?: string[];

  procedureName?: string;

  existingProcedureTaskId?: number;

  existingProcedureName?: string;

  descriptionDiffers?: boolean;

  checkListDiffers?: boolean;
}

export class InternalAuditImprovementDTO {
  comments?: InternalAuditCommentDTO[];

  unmatchedTasks?: InternalAuditUnmatchedTaskDTO[];

  // the improvement task already created from this audit's remarks, when it still exists
  improvementTaskId?: number;

  // when the criteria drafts of this audit were applied; set once
  criteriaImprovedOn?: string;
}

// What the model made of ONE comment: keyed back to it by task and KPI, never by quoted text
export class InternalAuditImprovementProposalDTO {
  taskId!: number;

  kpiId!: number;

  question?: string;

  comment?: string;

  commentHtml?: string;

  procedureTaskId?: number;

  procedureName?: string;

  entityType?: number;

  entityId?: number;

  criterionKey?: string;

  entityName?: string;

  evaluation?: string;

  recommendation?: string;
}

export class InternalAuditImprovementAnalysisDTO {
  proposals?: InternalAuditImprovementProposalDTO[];

  nothingToImprove?: boolean;
}

export class InternalAuditImprovementApplyDTO {
  proposals!: InternalAuditImprovementProposalDTO[];
}

// One proposed change to one audit criterion: the current texts, the drafted texts (edited by the user
// before approval) and the remarks it was written from
export class InternalAuditCriterionDraftDTO {
  entityType!: number;

  entityId!: number;

  entityName?: string;

  criterionKey!: string;

  originalRequirement?: string;

  originalSuccessCriteria?: string;

  proposedRequirement?: string;

  proposedSuccessCriteria?: string;

  remarks?: InternalAuditImprovementProposalDTO[];
}

export class InternalAuditCriterionSkippedDTO {
  entityType?: number;

  entityId?: number;

  entityName?: string;

  criterionKey?: string;

  reason?: string;

  remarks?: InternalAuditImprovementProposalDTO[];
}

export class InternalAuditCriteriaPreviewDTO {
  drafts?: InternalAuditCriterionDraftDTO[];

  skipped?: InternalAuditCriterionSkippedDTO[];
}

export class InternalAuditCriteriaApplyDTO {
  drafts!: InternalAuditCriterionDraftDTO[];
}

export class InternalAuditCriterionAppliedDTO {
  entityType!: number;

  entityId!: number;

  entityName?: string;

  oldCriterionKey?: string;

  newCriterionKey?: string;

  forked?: boolean;

  coveringProcedureNames?: string[];
}

export class InternalAuditCriteriaApplyResultDTO {
  applied?: InternalAuditCriterionAppliedDTO[];
}

export class InternalAuditImprovementResultDTO {
  taskId?: number;

  createdProcedureNames?: string[];

  updatedProcedureNames?: string[];

  linkedProcedureNames?: string[];
}

export class InternalAuditProcedureFromTasksDTO {
  taskIds!: number[];
}
